import { ChevronDown } from "lucide-react";
import { MouseEventHandler, ReactNode } from "react";
import { TravelIconDark } from "../Icons";
import { useTheme } from "next-themes";

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
};

export const DropdownButton = ({ children, onClick }: Props) => {
  const { resolvedTheme } = useTheme();

  return (
    <button
      type="button"
      className="py-4 px-6 border border-sleap-gray-400 rounded-full h-12 w-full md:w-auto md:px-2 md:py-1 md:border-none text-base font-switzer flex justify-between items-center gap-1 text-sleap-gray-700 dark:text-white dark:border-input"
      onClick={onClick}
    >
      <div className="flex gap-x-2">
        {/* <TravelIconDark color={resolvedTheme === "dark" ? "white" : "black"} /> */}
        <span>{children}</span>
      </div>
      <ChevronDown />
    </button>
  );
};
